import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-email-verification',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule],
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.scss']
})
export class EmailVerificationComponent implements OnInit, OnDestroy {
  emailForm: FormGroup;
  linkSent = false;
  timer = 60;
  interval: any;

  constructor(private fb: FormBuilder, private router: Router) {
    this.emailForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    if (this.interval) clearInterval(this.interval);
  }

  startTimer(): void {
    this.timer = 60;
    if (this.interval) clearInterval(this.interval);
    this.interval = setInterval(() => {
      if (this.timer > 0) this.timer--;
      else clearInterval(this.interval);
    }, 1000);
  }

  onSubmit(): void {
    if (this.emailForm.valid) {
      console.log('Email submitted', this.emailForm.value);
      this.linkSent = true;
      this.startTimer();
    } else {
      this.emailForm.markAllAsTouched();
    }
  }

  resendLink(): void {
    if (this.timer === 0) {
      console.log('Resending verification link');
      this.startTimer();
    }
  }
}
